var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEavesBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_3703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0991211 12.5V8L16.0991 14.5V16H10.0991L0.0991211 12.5Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0991 14.5L0.0991211 8V0H16.0991V14.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6972 -6.5L11.5632 -6L2.74911 9.2665L1.88309 8.7665L10.6972 -6.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09912 -8L8.96515 -7.5L-0.0198408 8.06245L-0.885866 7.56245L8.09912 -8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2953 -5L14.1613 -4.5L5.71261 10.1336L4.84658 9.63359L13.2953 -5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8934 -3.5L16.7594 -3L8.55485 11.2107L7.68882 10.7107L15.8934 -3.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4915 -2L19.3575 -1.5L11.3575 12.3564L10.4915 11.8564L18.4915 -2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0895 -0.5L21.9556 0L13.9556 13.8564L13.0895 13.3564L21.0895 -0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.925 14.9687L-0.574982 8.46874L-0.226795 7.53131L17.2732 14.0313L16.925 14.9687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9134 17.4642L-0.586578 12.4642L-0.215188 11.5358L12.2848 16.5358L11.9134 17.4642Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_3703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0991211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEavesBoard);
export default __webpack_public_path__ + "static/media/eaves-board.deed3a7034a7e9c877a626517e2b09ec.svg";
export { ForwardRef as ReactComponent };